import React, { useEffect, useState } from "react";
import "../index.css";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";
import {
  getDateWithoutMonthName,
  investmentDetailsPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
function EditInvestor() {
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  const location = useLocation();
  const [countryDropDown, setcountryDropDown] = useState([]);
  const myparam = location.state;
  let form = {
    enquiry: 1,
    communication: 1,
    interest: 1,
    reason_notinterest: "",
    politeness: 1,
    family_background: "",
    goal: "",
    previous_investment: 1,
    inv_exp: "",
    broker_quantum: "",
    advisor_quantum: "",
    loc_state: "",
    loc_country: "",
  };
  const reasonMapper = {
    1: "Requested for sign up but did not do it",
    2: "Left Abruptly",
    3: "Other reason",
  };
  const reasonReverseMapper = {
    "Requested for sign up but did not do it": "1",
    "Left Abruptly": "2",
    "Other reason": "3",
  };
  const [formObject, setFromObject] = useState(form);

  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "How did you get to know about Savart?",
      imp: false,
      filedType: "dropDown",
      value: "enquiry",
      display: true,
    },
    {
      lable: "Communication Preference",
      imp: true,
      filedType: "dropDown",
      value: "communication",
      display: true,
    },
    {
      lable: "Was he/ She interested in the services?",
      imp: false,
      filedType: "dropDown",
      value: "interest",
      display: true,
      boolean: true,
    },
    {
      lable: "If not interested, what was the reason for disinterest?",
      imp: false,
      filedType: "text",
      value: "reason_notinterest",
      display: true,
    },
    {
      lable: "Was he/ She polite with communication",
      imp: false,
      filedType: "dropDown",
      value: "politeness",
      display: true,
      boolean: true,
    },
    {
      lable: "Family background",
      imp: false,
      filedType: "text",
      value: "family_background",
      display: true,
    },
    {
      lable: "Goal Details",
      imp: false,
      filedType: "text",
      value: "goal",
      display: true,
    },
    {
      lable: "Have you ever invested before?",
      imp: false,
      filedType: "dropDown",
      value: "previous_investment",
      display: true,
      boolean: true,
    },
    {
      lable: "If yes, How was your experience?",
      imp: false,
      filedType: "text",
      value: "inv_exp",
      display: true,
      disableCondition: "previous_investment",
      disableValue: 4,
    },
    {
      lable: "If yes, with which broker? what was the quantum?",
      imp: false,
      filedType: "text",
      value: "broker_quantum",
      display: true,
      disableCondition: "previous_investment",
      disableValue: 4,
    },
    {
      lable: "If yes, with which adivisor? what was the quantum?",
      imp: false,
      filedType: "text",
      value: "advisor_quantum",
      display: true,
      disableCondition: "previous_investment",
      disableValue: 4,
    },
    {
      lable: "Status",
      imp: false,
      filedType: "dropDown",
      value: "status",
      display: false,
    },
    {
      lable: "Country",
      imp: false,
      filedType: "dropDown",
      value: "loc_country",
      display: false,
    },

    // { "lable": "Prospect Location", "filedType": "dropDown" ,"value":"loc_country"},
  ];
  const classes = useStyles();
  const getDropdownValue = (field, text, boolean, data) => {
    if (text) {
      let CurrentQuestion = userQuestionnaire.filter((obj) => {
        return obj["value"] === field;
      });
      let current = [];
      if (CurrentQuestion && CurrentQuestion.length > 0) {
        current = data.filter((obj) => {
          return obj["question"] === CurrentQuestion[0]["lable"];
        });
      }
      if (boolean && text && text === true) {
        return 1;
      } else if (boolean && !text) {
        return 0;
      } else if (current && current.length > 0) {
        let value = current[0].options.filter((option) => {
          return option.name === text;
        });
        if (value.length > 0) {
          return value[0]["values"];
        } else {
          return 1;
        }
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  };

  const handleCancel = () => {
    if (myparam && myparam.customer_id) {
      http
        .get("/edit_user_questionnaire/" + myparam.customer_id + "/")
        .then((response) => {
          if (
            response.data &&
            response.data.dropdowns &&
            Array.isArray(response.data.dropdowns) &&
            response.data.dropdowns.length > 0
          ) {
            setQuestionner(response.data.dropdowns);
            let countryList = response.data.dropdowns.filter((obj) => {
              return obj.question === "Country";
            });
            if (
              countryList &&
              countryList.length > 0 &&
              countryList[0]["options"] &&
              Array.isArray(countryList[0]["options"])
            ) {
              setcountryDropDown(countryList[0]["options"]);
            }
          }
          if (response.data && response.data.Data) {
            let questionData = {};

            questionData = response.data.Data;
            let updatedForm = {
              enquiry: getDropdownValue(
                "enquiry",
                questionData.enquiry,
                false,
                response.data.dropdowns
              ),
              communication: getDropdownValue(
                "communication",
                questionData.communication,
                false,
                response.data.dropdowns
              ),
              interest: getDropdownValue(
                "interest",
                questionData.interest,
                true,
                response.data.dropdowns
              ),
              reason_notinterest: questionData.reason_notinterest,
              politeness: getDropdownValue(
                "politeness",
                questionData.politeness,
                true,
                response.data.dropdowns
              ),
              family_background: questionData.family_background,
              goal: questionData.goal,
              previous_investment: getDropdownValue(
                "previous_investment",
                questionData.previous_investment,
                false,
                response.data.dropdowns
              ),
              inv_exp: questionData.inv_exp,
              broker_quantum: questionData.broker_quantum,
              advisor_quantum: questionData.advisor_quantum,
              loc_state: questionData.loc_state,
              loc_country: questionData.loc_country,
            };
            setFromObject(updatedForm);
          } else {
            toast.error("Permission denied..!");
            gotoProspectDetails();
          }
        })
        .catch((error) => {
          // toast.error("Questioner Data Not Available for this investor..!");
          gotoProspectDetails();

          // history.goBack();
        });
    } else {
      history.goBack();
    }
  };
  useEffect(() => {
    handleCancel();
  }, []);
  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let setObject = { ...formObject };
    if (name === "previous_investment" && value === 4) {
      setObject["inv_exp"] = "";
      setObject["broker_quantum"] = "";
      setObject["advisor_quantum"] = "";
      setObject["previous_investment"] = value;
      setFromObject(setObject);
    } else {
      setFromObject({
        ...formObject,
        [event.target.name]: event.target.value,
      });
    }
  };
  const gotoProspectDetails = () => {
    history.push({
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setFromObject({
      ...formObject,
      addProspectBtnClick: true,
    });
    let finalObjet = { ...formObject };
    userQuestionnaire.map((obj) => {
      let filter = [];
      if (obj["filedType"] == "dropDown" && !obj["boolean"]) {
        filter = questionner.filter((question) => {
          return question.question === obj.lable;
        });
        if (filter.length > 0) {
          let value = filter[0].options.filter((option) => {
            return option.values === finalObjet[obj.value];
          });
          if (value.length > 0) {
            finalObjet[obj.value] = value[0]["name"];
          }
        }
      }

      if (obj["boolean"] && finalObjet[obj.value] != 1) {
        finalObjet[obj.value] = 0;
      }
    });
    http
      .put("/edit_user_questionnaire/" + myparam.customer_id + "/", finalObjet)
      .then((response) => {
        if (response.data.id) {
          toast.success("Questioner Updated Successfully..!");
          gotoProspectDetails();
          handleCancel();
        } else {
          toast.error("Questioner Updation  Failed..!");
        }
        setFromObject({
          ...formObject,
          addProspectBtnClick: false,
        });
        // setFromObject(form)
      })
      .catch((error) => {
        setFromObject({
          ...formObject,
          addProspectBtnClick: false,
        });
        toast.error("Questioner Updation  Failed..!");
      });
  };

  return (
    <>
      <Grid container component="main" className={("overviewbar", "pb30")}>
        <Grid item xs={false} sm={5} md={5}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={false} sm={5} md={5}>
          <Typography color="textPrimary" variant="h5">
            Questionnaire
          </Typography>
        </Grid>
        {userQuestionnaire.map((question) => {
          return question.display ? (
            <Grid container className={classes.paper}>
              <Grid item xs={12} sm={5} md={5} className={"formLable"}>
                <InputLabel
                  className={classes.lableColor}
                  id={question.lable + "label"}
                >
                  {question.lable}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
              </Grid>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                {question.filedType === "dropDown" ? (
                  questionner
                    .filter((obj) => {
                      return obj.question === question.lable;
                    })
                    .map((a) => {
                      return (
                        <Select
                          displayEmpty
                          labelId={question.lable + "label"}
                          id="statusSelect"
                          variant="outlined"
                          className={classes.select}
                          onChange={handleChange}
                          value={
                            formObject[question.value]
                              ? formObject[question.value]
                              : ""
                          }
                          name={question.value}
                        >
                          <MenuItem value="">Select</MenuItem>
                          {a.options.map((option) => {
                            return (
                              <MenuItem value={option.values}>
                                {option.name}
                              </MenuItem>
                            );
                          })}
                          )
                        </Select>
                      );
                    })
                ) : (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    disabled={
                      question.disableCondition &&
                      formObject.hasOwnProperty(question.disableCondition) &&
                      formObject[question.disableCondition] ===
                      question.disableValue
                    }
                  />
                )}
              </Grid>
            </Grid>
          ) : (
            ""
          );
        })}
        <Grid container className={classes.paper}>
          <Grid item xs={12} sm={5} md={5}>
            <InputLabel className={classes.lableColor} id="locatonLable">
              Investor Location
            </InputLabel>
          </Grid>

          <Grid item xs={12} sm={2} md={1}>
            <TextField
              id="standard-basic"
              label="State"
              variant="outlined"
              value={formObject.loc_state}
              onChange={handleChange}
              name="loc_state"
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Select
              displayEmpty
              labelId="Country"
              id="Country"
              variant="outlined"
              className={classes.select}
              onChange={handleChange}
              value={formObject.loc_country ? formObject.loc_country : ""}
              name="loc_country"
            >
              <MenuItem value="">Select</MenuItem>
              {countryDropDown.map((option) => {
                return (
                  <MenuItem value={option.locname}>{option.locname}</MenuItem>
                );
              })}
              )
            </Select>
          </Grid>
        </Grid>
        <Grid container className={classes.submitButton}>
          <Grid item xs={12} sm={5} md={5}></Grid>
          <Grid item xs={12} sm={1} md={1}>
            <Button
              variant="contained"
              color="default"
              onClick={handleCancel}
              className="addBtn"
            >
              Cancel
            </Button>
          </Grid>

          <Grid item xs={12} sm={1} md={1}>
            {formObject.addProspectBtnClick ? (
              <Button
                variant="contained"
                color="primary"
                disabled
                className="addBtn"
              >
                Update
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                className="addBtn"
              >
                Update
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default EditInvestor;
